(() => {
  const CARE_LIMITS = {
    normal30: { maxTemp: 30, process: 'normal', label: '30°C normaal' },
    mild30: { maxTemp: 30, process: 'mild', label: '30°C mild' },
    veryMild30: { maxTemp: 30, process: 'veryMild', label: '30°C zeer mild' },
    normal40: { maxTemp: 40, process: 'normal', label: '40°C normaal' },
    mild40: { maxTemp: 40, process: 'mild', label: '40°C mild' },
    veryMild40: { maxTemp: 40, process: 'veryMild', label: '40°C zeer mild' },
    normal60: { maxTemp: 60, process: 'normal', label: '60°C normaal' },
    mild60: { maxTemp: 60, process: 'mild', label: '60°C mild' },
    normal95: { maxTemp: 95, process: 'normal', label: '95°C normaal' },
    handAmbient: { maxTemp: 30, process: 'hand', label: 'handwas 20–30°C' },
    hand40: { maxTemp: 40, process: 'hand', label: 'handwas tot 40°C' },
    doNotWash: { maxTemp: null, process: 'blocked', label: 'niet wassen' },
    unknown: { maxTemp: null, process: 'unknown', label: 'onbekend label' }
  };

  const LOAD_PROFILES = {
    cotton: { name: 'dagelijkse katoen of mix', cycle: 'Katoen of passend gemengd programma', light: 30, normal: 40, heavy: 40, spin: '1.000–1.200 tpm', product: true },
    linen: { name: 'handdoeken of beddengoed', cycle: 'Katoenprogramma', light: 40, normal: 60, heavy: 60, spin: '1.200–1.400 tpm', product: true },
    synthetic: { name: 'synthetische of kreukherstellende was', cycle: 'Synthetisch / kreukherstellend', light: 30, normal: 40, heavy: 40, spin: '800–1.000 tpm', product: true },
    sports: { name: 'sportkleding', cycle: 'Sport of synthetisch', light: 30, normal: 30, heavy: 30, spin: 'maximaal 800 tpm', product: true },
    dark: { name: 'donkere kleding', cycle: 'Donkere was of passend katoen/mix', light: 30, normal: 30, heavy: 30, spin: '800–1.000 tpm', product: true },
    wool: { name: 'wol', cycle: 'Wolprogramma', light: 30, normal: 30, heavy: 30, spin: 'maximaal 600–800 tpm', product: false },
    delicate: { name: 'zijde of zeer delicate was', cycle: 'Fijnwas / zeer delicaat', light: 30, normal: 30, heavy: 30, spin: 'maximaal 400–600 tpm', product: false }
  };

  const COLOR_TEXT = {
    light: 'Sorteer wit en licht wasgoed en controleer of ieder artikel dezelfde behandeling toestaat.',
    colored: 'Sorteer lichte, felle en mogelijk afgevende kleuren; test nieuw gekleurd wasgoed zo nodig apart.',
    dark: 'Sorteer donker wasgoed apart en keer kleding binnenstebuiten wanneer label en fabrikant dit toelaten.'
  };

  const blockedAdvice = (profile) => ({
    title: 'Niet in de huishoudelijke wasmachine',
    badge: 'Stop: niet wassen',
    summary: `Het ingevoerde label staat huishoudelijk wassen niet toe. De keuze voor ${profile.name} verandert die grens niet.`,
    cycle: 'Niet wassen', temperature: 'Niet toepassen', spin: 'Niet centrifugeren', loading: 'Niet in de trommel',
    prepare: 'Laat het label aan het artikel zitten en wijs een professionele textielreiniger op vlekken, materiaal en afwerking.',
    detergent: 'Gebruik geen huishoudelijk wasmiddel of weekmiddel zonder uitdrukkelijke instructie van de fabrikant of reiniger.',
    avoid: 'Niet weken, handwassen of op een “voorzichtig” machineprogramma plaatsen. Een mild programma heft het kruis niet op.',
    showProduct: false
  });

  const unknownAdvice = (profile) => ({
    title: 'Controleer eerst het waslabel',
    badge: 'Nog geen veilige grens',
    summary: `Zonder leesbare onderhoudsinstructie kan de tool geen betrouwbare instelling voor ${profile.name} geven. Constructie, coating, lijm en decoraties kunnen belangrijker zijn dan de vermoedelijke vezel.`,
    cycle: 'Nog niet kiezen', temperature: 'Onbekend', spin: 'Onbekend', loading: 'Apart houden',
    prepare: 'Zoek de productinformatie van de kledingfabrikant of vraag een professionele textielreiniger.',
    detergent: 'Kies nog geen wasmiddel totdat duidelijk is of en hoe het artikel gewassen mag worden.',
    avoid: 'Niet gokken op basis van alleen kleur, uiterlijk of vezelnaam.',
    showProduct: false
  });

  const handAdvice = (care, profile, soil, color) => {
    const specialist = profile.product
      ? 'Gebruik een passend hand- of fijnwasmiddel en doseer exact volgens het etiket.'
      : `Gebruik uitsluitend een middel dat volgens het etiket geschikt is voor ${profile.name}; een standaardwasmiddel kan ongeschikt zijn.`;
    return {
      title: `Voorzichtige handwas voor ${profile.name}`,
      badge: care.label,
      summary: 'Het handwassymbool vraagt om handmatige behandeling met ruim water en heel weinig beweging. Een machineprogramma wordt niet automatisch toegestaan door de aanwezigheid van een handwasstand.',
      cycle: 'Handwas met de hand',
      temperature: care.maxTemp === 40 ? 'maximaal 40°C' : 'ongeveer 20–30°C',
      spin: 'Niet wringen',
      loading: 'Eén of enkele stukken in ruim water',
      prepare: `${COLOR_TEXT[color]} ${soil === 'heavy' ? 'Behandel een vlek alleen met een middel dat aantoonbaar geschikt is voor de stof.' : 'Sluit kwetsbare sluitingen en behandel het artikel snel zonder lang weken.'}`,
      detergent: specialist,
      avoid: 'Niet wrijven, trekken, wringen of lang nat laten liggen. Plaats het artikel alleen in de machine als de fabrikant dat afzonderlijk bevestigt.',
      showProduct: false
    };
  };

  const buildAdvice = ({ care: careKey, load: loadKey, soil, color }) => {
    const care = CARE_LIMITS[careKey];
    const profile = LOAD_PROFILES[loadKey];
    if (!care || !profile || !['light', 'normal', 'heavy'].includes(soil) || !COLOR_TEXT[color]) return null;
    if (care.process === 'blocked') return blockedAdvice(profile);
    if (care.process === 'unknown') return unknownAdvice(profile);
    if (care.process === 'hand') return handAdvice(care, profile, soil, color);

    let temperature = Math.min(care.maxTemp, profile[soil]);
    if (color === 'dark') temperature = Math.min(temperature, 40);

    let cycle = profile.cycle;
    let spin = profile.spin;
    let loading = 'Volg de programmagrens van uw machine';

    if (care.process === 'veryMild') {
      cycle = loadKey === 'wool' ? 'Wol / zeer mild' : 'Zeer mild / passend fijnwasprogramma';
      spin = 'maximaal 600 tpm of uit';
      loading = 'Hoogstens circa een derde trommel';
    } else if (care.process === 'mild') {
      cycle = loadKey === 'wool' ? 'Wolprogramma' : 'Mild / kreukherstellend';
      spin = 'maximaal 800 tpm, liefst kort';
      loading = care.maxTemp === 60 ? 'Hoogstens circa twee derde trommel' : 'Duidelijk minder dan de normale programmabelading';
    } else if ((loadKey === 'cotton' || loadKey === 'linen') && soil === 'normal' && care.maxTemp >= 40) {
      cycle = 'Eco 40–60 of katoenprogramma';
    }

    if (loadKey === 'wool') {
      cycle = care.process === 'veryMild' ? 'Wol / zeer mild' : 'Wolprogramma';
      spin = care.process === 'normal' ? 'maximaal 600–800 tpm' : spin;
      loading = care.process === 'normal' ? 'Kleine wolbelading volgens machine' : loading;
    } else if (loadKey === 'delicate') {
      cycle = care.process === 'veryMild' ? 'Zeer mild / fijnwas' : 'Fijnwas / zeer delicaat';
      spin = care.process === 'normal' ? 'maximaal 400–600 tpm' : spin;
      loading = care.process === 'normal' ? 'Kleine, losse belading' : loading;
    }

    const soilPreparation = soil === 'heavy'
      ? 'Behandel geschikte vlekken eerst en gebruik alleen een voorwasoptie als label, middel en machinehandleiding dat toestaan.'
      : soil === 'light'
        ? 'Gebruik geen zwaarder of heter programma dan nodig voor dit licht vervuilde wasgoed.'
        : 'Controleer zakken, sluit ritsen en maak de lading los voordat u de trommel vult.';

    let detergent = 'Doseer volgens het etiket van het wasmiddel en houd rekening met belading, vervuiling en waterhardheid. Volg bij een unit-dose capsule de productinstructie en maak de capsule niet open.';
    if (loadKey === 'wool') detergent = 'Gebruik alleen een wasmiddel dat volgens het etiket geschikt is voor wol. Standaard enzym- of bleekhoudende middelen kunnen ongeschikt zijn.';
    if (loadKey === 'delicate') detergent = 'Gebruik alleen een wasmiddel dat volgens het etiket geschikt is voor zijde of het betreffende delicate materiaal; test niet met een standaardmiddel.';
    if (loadKey === 'sports') detergent = 'Kies een wasmiddel dat geschikt is voor het technische materiaal en volg de kledingfabrikant over wasverzachter en coatings.';

    const temperatureNote = `${temperature}°C blijft onder of gelijk aan het ingevoerde labelmaximum van ${care.maxTemp}°C.`;
    const avoid = `Overschrijd ${care.maxTemp}°C niet en kies geen zwaarder proces dan “${care.label}”. Verhoog bij sterke vervuiling niet automatisch de temperatuur en droog pas met warmte als zichtbare vlekken weg zijn.`;

    return {
      title: `${temperature}°C voor ${profile.name}`,
      badge: care.label,
      summary: `${temperatureNote} De exacte programmanaam en werkelijke cyclus verschillen per wasmachine; controleer daarom de machinehandleiding.`,
      cycle, temperature: `${temperature}°C`, spin, loading,
      prepare: `${COLOR_TEXT[color]} ${soilPreparation}`,
      detergent,
      avoid,
      showProduct: profile.product
    };
  };

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { CARE_LIMITS, LOAD_PROFILES, buildAdvice };
    return;
  }

  class FfProgramGuide extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized) return;
      this.dataset.initialized = 'true';
      this.form = this.querySelector('[data-ff-program-form]');
      this.steps = Array.from(this.querySelectorAll('[data-ff-program-step]'));
      this.nextButton = this.querySelector('[data-ff-program-next]');
      this.backButton = this.querySelector('[data-ff-program-back]');
      this.error = this.querySelector('[data-ff-program-error]');
      this.result = this.querySelector('[data-ff-program-result]');
      this.currentStep = 0;
      this.state = {};

      this.nextButton?.addEventListener('click', () => this.next());
      this.backButton?.addEventListener('click', () => this.back());
      this.querySelector('[data-ff-program-restart]')?.addEventListener('click', () => this.restart());
      this.form?.addEventListener('change', () => { this.error.hidden = true; });
      this.querySelectorAll('[data-ff-program-share]').forEach((control) => control.addEventListener('click', (event) => this.share(event, control.dataset.ffProgramShare)));
      this.updateStep();
    }

    next() {
      const step = this.steps[this.currentStep];
      const field = step?.dataset.ffProgramStep;
      const checked = field ? this.form.querySelector(`input[name="${field}"]:checked`) : null;
      if (!checked) {
        this.error.hidden = false;
        step?.querySelector('input[type="radio"]')?.focus();
        return;
      }
      this.state[field] = checked.value;
      this.track('ff_program_step', { step: field, value: checked.value });
      if (this.currentStep < this.steps.length - 1) {
        this.currentStep += 1;
        this.updateStep(true);
      } else {
        this.showResult();
      }
    }

    back() {
      if (this.currentStep === 0) return;
      this.currentStep -= 1;
      this.updateStep(true);
    }

    updateStep(scroll = false) {
      this.steps.forEach((step, index) => { step.hidden = index !== this.currentStep; });
      this.querySelector('[data-ff-program-current]').textContent = String(this.currentStep + 1);
      this.querySelector('[data-ff-program-progress]').style.width = `${((this.currentStep + 1) / this.steps.length) * 100}%`;
      this.backButton.hidden = this.currentStep === 0;
      this.nextButton.innerHTML = this.currentStep === this.steps.length - 1 ? 'Toon mijn advies <span aria-hidden="true">→</span>' : 'Volgende <span aria-hidden="true">→</span>';
      this.error.hidden = true;
      if (scroll) this.querySelector('.ff-wash-guide__app-head')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    showResult() {
      const advice = buildAdvice(this.state);
      if (!advice) return;
      this.advice = advice;
      const fields = {
        '[data-ff-program-title]': advice.title,
        '[data-ff-program-badge]': advice.badge,
        '[data-ff-program-summary]': advice.summary,
        '[data-ff-program-cycle]': advice.cycle,
        '[data-ff-program-temperature]': advice.temperature,
        '[data-ff-program-spin]': advice.spin,
        '[data-ff-program-load]': advice.loading,
        '[data-ff-program-prepare]': advice.prepare,
        '[data-ff-program-detergent]': advice.detergent,
        '[data-ff-program-avoid]': advice.avoid
      };
      Object.entries(fields).forEach(([selector, value]) => { const node = this.querySelector(selector); if (node) node.textContent = value; });
      this.querySelector('[data-ff-program-product]').hidden = !advice.showProduct;
      this.form.hidden = true;
      this.querySelector('.ff-wash-guide__progress').hidden = true;
      this.querySelector('.ff-wash-guide__step-counter').hidden = true;
      this.result.hidden = false;
      this.updateShareLinks();
      this.result.scrollIntoView({ behavior: 'smooth', block: 'start' });
      this.track('ff_program_result', { care: this.state.care, load: this.state.load, soil: this.state.soil, color: this.state.color, temperature: advice.temperature });
    }

    restart() {
      this.form.reset();
      this.state = {};
      this.advice = null;
      this.currentStep = 0;
      this.form.hidden = false;
      this.result.hidden = true;
      this.querySelector('.ff-wash-guide__progress').hidden = false;
      this.querySelector('.ff-wash-guide__step-counter').hidden = false;
      this.updateStep(true);
    }

    updateShareLinks() {
      if (!this.advice) return;
      const message = `Mijn FashFresh Wasprogramma Keuzehulp: ${this.advice.title}. Het waslabel gaat altijd voor.`;
      const url = window.location.href;
      const whatsapp = this.querySelector('[data-ff-program-share="whatsapp"]');
      const facebook = this.querySelector('[data-ff-program-share="facebook"]');
      if (whatsapp) { whatsapp.href = `https://wa.me/?text=${encodeURIComponent(`${message} ${url}`)}`; whatsapp.target = '_blank'; whatsapp.rel = 'noopener'; }
      if (facebook) { facebook.href = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`; facebook.target = '_blank'; facebook.rel = 'noopener'; }
    }

    async share(event, platform) {
      if (platform === 'whatsapp' || platform === 'facebook') return;
      event.preventDefault();
      if (!this.advice) return;
      const shareData = { title: 'FashFresh Wasprogramma Keuzehulp', text: `${this.advice.title}. Het waslabel gaat altijd voor.`, url: window.location.href };
      try {
        if (platform === 'native' && navigator.share) await navigator.share(shareData);
        else {
          await navigator.clipboard.writeText(`${shareData.text} ${shareData.url}`);
          this.showShareStatus('Link en advies gekopieerd.');
        }
      } catch (error) {
        if (error?.name !== 'AbortError') this.showShareStatus('Kopiëren lukte niet. Kopieer de adresbalk handmatig.');
      }
    }

    showShareStatus(message) {
      const status = this.querySelector('[data-ff-program-share-status]');
      if (!status) return;
      status.textContent = message;
      status.hidden = false;
    }

    track(eventName, detail) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: eventName, ...detail });
    }
  }

  if (!customElements.get('ff-program-guide')) customElements.define('ff-program-guide', FfProgramGuide);
})();
